import React, { useState } from "react";
import { useLanguage } from "../i18n";

type Props = Omit<React.InputHTMLAttributes<HTMLInputElement>, "type">;

// Masked by default; the eye button reveals the text so a user can check
// what they typed. Rendered inside the same .input-wrap the plain inputs use.
export function PasswordInput(props: Props) {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);
  const label = visible ? t("auth.hidePassword") : t("auth.showPassword");
  return (
    <div className="input-wrap">
      <input {...props} type={visible ? "text" : "password"} />
      <button type="button" className="pw-eye" onClick={() => setVisible((v) => !v)} aria-label={label} title={label}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" />
          <circle cx="12" cy="12" r="3" />
          {visible && <path d="M3 3l18 18" />}
        </svg>
      </button>
    </div>
  );
}
